import Component from '../abstracts/Component';
import { isMobile, MobileBreakpoint } from '../utils/MobileUtils';

export default class ListingEditorialComponent extends Component {
  get SELECTORS() {
    return {
      listingPush: '[data-listing-push]',
      listingVerticalPush: '[data-listing-vertical-push]',
      listingPushVerticalVariant: '[data-listing-push].type-vertical',
      listingVerticalPushImage: '[data-vertical-push-image]',
      listingVerticalPushTextContainer: '[data-vertical-push-text-container]',
      listingPushTextContainer: '[data-push-text-container]',
      listingPushImage: '[data-push-image]',
      product: '[data-product-card]',
      productImage: '[data-product-card-img-container]',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.product = this.$component.querySelector(this.SELECTORS.product);
    if (this.product != null ) {
      this.productImage = this.product.querySelector(this.SELECTORS.productImage);
    }
  }

  setListingVerticalPushHeight() {
    if (isMobile(MobileBreakpoint.Max767)) return;
    if (this.productImage == null )  return;
    let editorials = this.$component.querySelectorAll(
      this.SELECTORS.listingVerticalPush
    );
    editorials.forEach(element => {
      let image = element.querySelector(
        this.SELECTORS.listingVerticalPushImage
      );
      image.style.height = `${this.product.offsetHeight +
        parseInt(getComputedStyle(this.product).marginBottom) + this.productImage.offsetHeight}px`;
    });
  }

  setListingPushHeight() {
    if (isMobile(MobileBreakpoint.Max767)) return;
    if (this.productImage == null )  return;
    let editorials = this.$component.querySelectorAll(
      this.SELECTORS.listingPushVerticalVariant
    );
    editorials.forEach(element => {
      let image = element.querySelector(this.SELECTORS.listingPushImage);
      image.style.height = `${this.productImage.offsetHeight}px`;
      if (!isMobile(MobileBreakpoint.Max767)) {
        let textContainer = element.querySelector(
          this.SELECTORS.listingPushTextContainer
        );
        textContainer.style.marginTop = `${(element.offsetHeight -
          image.offsetHeight -
          textContainer.offsetHeight) /
          2}px`;
      }
    });
  }

  bindEvents() {
    let ctx = this;
    //hides editorial content after filtering
    // this.$on(this.$customEvents.FILTERS_EVENTS.pageLoaded, function() {
    //   document.querySelectorAll(ctx.SELECTORS.listingPush).forEach( function(item) {
    //     item.classList.add('--hidden');
    //   });
    //   document.querySelectorAll(ctx.SELECTORS.listingVerticalPush).forEach( function(item) {
    //     item.classList.add('--hidden');
    //   })
    // })
  }

  render() {
    super.render();
    this.bindEvents();
    // this.setListingVerticalPushHeight();
    // this.setListingPushHeight();
    // window.addEventListener('resize', () => {
    //   this.setListingVerticalPushHeight();
    //   this.setListingPushHeight();
    // });
  }
}
